module.exports = __webpack_public_path__ + "static/media/whatsapp.acf51bc4.svg";